import type { MarketplaceIdentifier } from "@opensea/graphql"
import {
  BlurLogo,
  CryptoPunksLogo,
  GammaLogo,
  type IconComponent,
  MagicEdenLogo,
  OKXLogo,
  OpenSeaLogo,
  OrdinalsMarketLogo,
  OrdinalsWalletLogo,
  UnisatLogo,
} from "@opensea/ui-kit/icons"

const MARKETPLACE_LOGOS: Partial<Record<MarketplaceIdentifier, IconComponent>> =
  {
    opensea: OpenSeaLogo,
    blur: BlurLogo,
    magiceden: MagicEdenLogo,
    unisat: UnisatLogo,
    gamma: GammaLogo,
    okx: OKXLogo,
    ordinalsmarket: OrdinalsMarketLogo,
    ordinalswallet: OrdinalsWalletLogo,
    cryptopunks: CryptoPunksLogo,
  } as const

export type MarketplaceLogo = { icon: IconComponent | null }

export function getMarketplaceLogo(
  identifier: MarketplaceIdentifier | undefined,
): MarketplaceLogo {
  if (!identifier) {
    return { icon: null }
  }

  const logo = MARKETPLACE_LOGOS[identifier]

  return {
    icon: logo ?? null,
  }
}
